/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Schedule } from '@src/app/model/schedule';
import { ScheduleValidation } from '@src/app/model/schedule-delta';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { uuid } from '@src/app/model/abstract-object';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService extends AbstractHttpService {
  protected http = inject(HttpClient);
  protected messageService = inject(MessageService);


  protected get baseUrl() {
        return this.getAjaxPath('budgets/schedules');
  }
  protected cache: Schedule[];
  protected typeString = 'Schedule';

  /** Asks the server what would change if the schedule were recalculated against the current
   * units. Read only - nothing is applied until the schedule is saved again.
   */
  validateSchedule(id: uuid): Observable<ScheduleValidation> {
      return this.http.get<ScheduleValidation>(`${this.baseUrl}/${id}/validate`, this.httpOptions)
          .pipe(catchError(this.handleError<ScheduleValidation>('validate' + this.typeString)));
  }

  /** Writes the portions the validation showed. The server recalculates them - we send nothing
   * but the id and revision - and returns the refreshed schedule.
   */
  applySchedulePortions(id: uuid, revision: number): Observable<Schedule> {
      const url = `${this.baseUrl}/${id}/${revision}/applySchedulePortions`;
      return this.http.put<Schedule>(url, null, this.httpOptions)
          .pipe(catchError(this.handleError<Schedule>('apply' + this.typeString + 'Portions')));
  }
}
